import { render, staticRenderFns } from "./ContractHero.vue?vue&type=template&id=10f6a955&"
import script from "./ContractHero.vue?vue&type=script&lang=js&"
export * from "./ContractHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports